<div id="terms" class="terms">
  <div class="shadow"></div>
  <div class="video">
    <video loop autoplay #videoBackground [muted]="true">
      <source
        src="https://d2z7yiz3wla4oq.cloudfront.net/videos/ride-run.mp4"
        type="video/mp4" />
      Sorry, your browser doesn't support embedded videos.
    </video>
  </div>
  <!-- English Part -->
  <div *ngIf="isEnglish" class="container-fluid content">
    <h1 class="mt-3 text-center">TERMS OF USE</h1>

    <ul class="list-group text-justify">
      <li class="list-group-item mt-5">
        <p>
          The items below concern the Kinomap platform, the Kinomap application
          and the Tunturi Routes application.
        </p>
      </li>
      <h2 class="mt-5">Preamble and definition</h2>
      <li class="list-group-item">
        <p>
          KINOMAP SAS (hereinafter, referred to as the "Company", "We" or
          "KINOMAP") hosts the KINOMAP website at www.kinomap.com (hereinafter,
          referred to as the "Site"), develops several software applications and
          offers (hereinafter, referred to as the "Services"). The present text
          defines the Terms of Services of KINOMAP (hereinafter, designated as
          "the Terms"). These Terms apply to both ordinary users and registered
          users (hereinafter referred to as “Users” and "Registered Users"). The
          Terms take effect when you use the Site or Services and remain in
          effect until terminated in accordance with the Terms. Registered Users
          are required to accept the Terms by clicking on "I agree". By
          accepting the Terms, the Users certifies that he/she has read and
          understood the contents of the Terms, and accepts the obligations set
          forth therein.
        </p>
      </li>

      <h2 class="mt-5">Services and registration</h2>
      <li class="list-group-item">
        <p>
          The Company provides the Services freely. However, certain services or
          features of the Services are only available to Registered Users who
          have purchased a subscription, including but not limited to the
          ability to upload and share videos on the Site and the ability to
          comment on videos on the Site.
        </p>
        <p>User registration :</p>
        <ul>
          <li>
            You shall only have one account as a Registered User and must
            provide the Company with your username, email address and password.
          </li>
          <li>
            You may also provide your first and last name, if you wish to. You
            may not create a Registered User account on behalf of another person
            or entity.
          </li>
          <li>
            You may also log in to the Services using your Facebook account.
          </li>
          <li>
            You may only use the Site and Services for your personal use and not
            for commercial use.
          </li>
          <li>
            You may not register to use the Site or download the Services if you
            are under the age of 15.
          </li>
          <li>
            To purchase a paid subscription you may use a credit card, or use an
            internet payment company such as Stripe, Paypal or Mercanet.
          </li>
        </ul>
      </li>

      <h2 class="mt-5">Behavior and obligations of the user</h2>
      <li class="list-group-item">
        <p>
          You agree to use the Site and Services only for lawful purposes and
          agree to comply with all applicable laws, rules and regulations in the
          geographic area in which you reside, including all community,
          national, federal, state or local legislations, rules and
          regulations.In addition, you agree that:
        </p>
        <ul>
          <li>
            You will not use the Services to upload, post, share or transmit any
            content that is: illegal, abusive, threatening, harmful, obscene,
            lewd, offensive, defamatory or otherwise objectionable ;
          </li>
          <li>
            You shall not sell, offer for sale, or advertise any weapons,
            ammunition, drugs, alcohol, pornography, or any other illegal goods
            or services through the use of the Site or the Services;
          </li>
          <li>
            You shall not engage in any activities that may disseminate computer
            viruses, malware or other programs, files or code designed to
            interrupt, destroy, access or limit the functionality of any
            computer software or hardware or telecommunications equipment;
          </li>
          <li>
            You shall not disseminate, post, share or transmit any content or
            other material through the use of the Services or the Site that
            constitutes unsolicited advertising, promotional materials, surveys,
            spam, junk mail or other unsolicited bulk or duplicate messages;
          </li>
          <li>
            You shall not disrupt or place unreasonable or excessive burdens on
            the Site, interfere with or attempt to gain unauthorized access to
            any portion of the Site, the Services or any computer system, server
            or support network;
          </li>
          <li>
            You shall not sell, rent, license or transfer your registration, or
            access to, or use of the Services to any third party and you shall
            not use the Site or the Services for any purpose other than
            personal, non-commercial use without the prior written consent of
            the Company;
          </li>
          <li>
            You may share content, including videos, from this Site via the
            sharing methods provided by the Company on the Site, but you may not
            redistribute the content of the Site in any other manner or for
            commercial purposes;
          </li>
          <li>
            You may not impersonate any other person or misrepresent to the
            Company or any other user your true legal identity; you may not use
            the Services in a fraudulent, deceptive or misleading manner;
          </li>
          <li>
            You shall not reproduce, duplicate, copy or reverse engineer the
            Site, any part there of or the Services, including any KINOMAP
            software applications available on the Site;.
          </li>
          <li>
            You shall not disseminate, transmit or make available to third
            parties any information, material or content that infringes
            fundamental rights and public freedoms recognized in the
            Constitution and in international treaties.
          </li>
        </ul>
        <h4 class="text-center mt-3">
          You may report violations of the Terms by contacting the Company at
          <a href="mailto:support@kinomap.com">support&#64;kinomap.com</a>.
        </h4>
      </li>

      <h2 class="mt-5">Relationships with Third Parties</h2>
      <li class="list-group-item">
        <p>
          You acknowledge and agree that your relationships with third parties,
          including mobile app stores, advertisers, social networking sites or
          other parties, found on, or accessible through, this Site, or who
          provide access to the Services and their products or services, are
          only between you and such third parties and Company will not be liable
          for any loss or damage related to your use of or interaction with any
          of third parties.
        </p>
        <p>
          Your activities on third party websites are governed by the terms and
          conditions and privacy policies of those sites and not by the Terms.
        </p>
        <p>
          You understand and acknowledge that some of the services that may be
          or become available on this Site may be provided by third parties and
          that in some cases, Company may receive advertising, sponsorship or
          licensing fees and/or other compensation from third parties.
        </p>
      </li>

      <h2 class="mt-5">Data Collection</h2>
      <li class="list-group-item">
        <p>
          Company may share, sell, license, or trade anonymized data that it
          collects about Users of the Site and the videos they watch, share, or
          download, including data about the date, time, and location of such
          use.
        </p>
        <p>
          You acknowledge and agree that the Company may intercept, collect,
          store, disclose, share and sell all anonymized data about your use of
          the Site and Services, including any data associated with or embedded
          in the videos you upload to our site. You may change your consent at
          any time by sending an email to support&#64;kinomap.com.<a
            href="mailto:support@kinomap.net"
            >support&#64;kinomap.com</a
          >.
        </p>
        <p>
          We invite you to review our Privacy Policy
          <a href="/privacy">https://www.kinomap.com/privacy</a> for more
          information about the data We collect and how We use it. You may
          change, delete and manage your data collected by the Company by
          sending an email to
          <a href="mailto:support@kinomap.net">support&#64;kinomap.com</a>.
        </p>
        <p>
          If you wish to opt-out, you must cancel your Registered User account,
          stop using the Site and the Services.
        </p>
      </li>

      <h2 class="mt-5">Changes of the Terms</h2>
      <li class="list-group-item">
        <p>
          We will notify Registered Users of the Site and/or Services via the
          email address provided during the registration if any changes to the
          Terms occur. The Company will use commercially reasonable means to
          notify you, via the Services on your mobile device or by email, that
          the Terms have been changed.
        </p>

        <p>
          Such amendments shall be effective upon the Company's posting of the
          Terms as revised on the Site.
        </p>
        <p>
          We will notify Registered Users of the Site and/or Services via the
          email address provided during the registration if any changes to the
          Terms occur. The Company will use commercially reasonable means to
          notify you, via the Services on your mobile device or by email, that
          the Terms have been changed.
        </p>
        <p>
          You agree to regularly check to see if you are aware of any changes to
          the Terms. Thus, you accept and agree to be bound by the revised Terms
          as posted on the Site at the time of your use.
        </p>
        <p>
          If you do not agree with any change to the Terms, you shall stop using
          the Site and the Services and cancel your account.
        </p>
      </li>

      <h2 class="mt-5">Termination</h2>
      <li class="list-group-item">
        <p>
          The Company reserves the right to suspend or terminate the Services,
          in whole or in part, at any time at its sole discretion.
        </p>

        <p>
          It includes the ability to terminate the rights of any Registered User
          to use the Site or Services in the event of Registered User's
          misconduct, threats or allegations thereof, excessive traffic on the
          Site or Services that impedes normal use and access of the Site or
          Services by other users, or any violation of the Terms.
        </p>
        <p>
          Users may terminate the Terms at any time by ending all use of the
          Services and the Site, deleting or permanently removing all copies of
          the Kinomap Applications from User's computers, tablets and mobile
          devices, and canceling User's Kinomap Registered User account.
        </p>
        <p>
          The following clauses survive termination: Content, Disclaimer of
          Warranties and Limitation of Liability, Compensation by User,
          Copyright Infringement, and the Additional Provisions.
        </p>
      </li>

      <h2 class="mt-5">Content</h2>
      <li class="list-group-item">
        <p>
          As a Registered User, you have the ability to share your videos on the
          Site. Videos uploaded by you to the Site can be viewed by anyone in
          the world.
        </p>
        <p>
          As a Registered User, you have the ability to share your videos on the
          Site. Videos uploaded by you to the Site can be viewed by anyone in
          the world.
          <li>
            your Registered User name; the date, time and location from which
            the video was uploaded;
          </li>
          <li>
            the date, time and location of the video's creation, including the
            starting point, route and ending point;
          </li>
          <li>
            GPS information of the route in the video, including altitude,
            speed, frequency, power, distance, location and time; heart rate;
          </li>
          <li>
            and the mode of transportation used to film the video. If your name,
            voice or physical likeness appears or is used in the video, it will
            also be publicly available.
          </li>
        </p>
        <p>
          You hereby grant the Company a non-exclusive, royalty-free right to
          use and reproduce, for any purpose related to the Company's provision
          of the Services, the Site and the Application, your name and/or
          Registered User name, voice and physical likeness, as well as the
          names, voices and physical likenesses of all other persons appearing
          in any video you upload to the Site and make available to the public.
          If you upload a video to the Site that is accessible only on a private
          (unlisted) basis, this right of use will not apply. You may put a
          video in both private and public mode at any time.
        </p>
        <p>
          The right to use includes the right to reproduce, which means putting
          the Videos online on the Website.
        </p>
        <p>
          The right to use includes the right of representation which means the
          broadcasting of the Videos and their use by the KINOMAP users using
          either the embeddable player, or having white label applications
          edited by Kinomap or via any other license agreement.
        </p>
        <p>
          You represent and warrant to Company that you have obtained all
          necessary authorizations and consents to grant such rights to the
          Company.
        </p>
        <p>
          You shall only post, create and upload to the Site content for which
          you have all necessary right, title and interest to grant the licenses
          set forth in these Terms. By creating Content on the Site or uploading
          videos to the Site, you warrant to the Company that you have all
          right, title and interest or appropriate authority necessary to share
          the Content and/or video through our Site and that you are not
          violating the rights of any third party.
        </p>
        <p>
          Your license to use the Application is governed by the Terms and by
          the End User License Agreement that you agreed to at the time of
          download or registration.
        </p>
        <p>
          You may not claim the ownership, distribute, sell, or extract the
          Content, nor exploit the Content for commercial purposes.
        </p>
        <p>
          You may not use the Site Content in any manner not expressly permitted
          by the Terms, and if you do so, your right to use the Site Content
          will automatically terminate.
        </p>
        <p>
          The Content and the Site may be modified or deleted without notice.
        </p>
        <p>
          You may delete your own videos and other Site Content that you have
          previously posted and shared on the Site.
        </p>
        <p>
          Videos and other user-generated content on the Site may be changed,
          modified, altered, deleted or removed at any time by the Company.
        </p>
      </li>

      <h2 class="mt-5">Technical Support</h2>
      <li class="list-group-item">
        <p>
          During your use of the Services, the Company will endeavor to provide
          its Users with commercially reasonable technical support regarding the
          use of the Services and the Site. This support is available via
          <a
            href="https://support.kinomap.com"
            target="_blank"
            rel="noopener noreferrer"
            >support.kinomap.com</a
          >
          ou par courriel à
          <a href="mailto:support@kinomap.net">support&#64;kinomap.com</a>.
        </p>
        <p>
          The Company won’t be liable for any delay, failure or interruption of
          the Services or access to the Site for any reason.
        </p>
        <p>
          Users are required to notify the Company immediately of any service
          interruption. The Company is also not liable for any errors,
          omissions, interruptions, delays or defects in the Services caused by
          the negligence or willful act of a User or their equipment, Internet
          service provider or mobile operator.
        </p>
      </li>

      <h2 class="mt-5">Disclaimer of Warranties and Limitation of Liability</h2>
      <li class="list-group-item">
        <p>
          The Company makes no warranties of any kind, express or implied,
          regarding the operation of the Site and the Services, the Application
          available on the Site, or the information, content, materials or
          products included on the Site. You expressly agree that your use of
          the Site, the Services and the Application is at your sole risk.
        </p>
        <p>
          To the extent permitted by applicable law, the Company disclaims all
          warranties, express or implied, including, but not limited to, the
          implied warranties of merchantability, fitness for a particular
          purpose and non-infringement. The Company does not warrant that the
          Site, its servers, the content of the Site, or the Company's Kinomap
          Applications are free of viruses or other harmful components and User
          expressly waives any claim in this regard.
        </p>
        <p>
          The Company will not be liable for any indirect, incidental, special,
          punitive or consequential damages of any kind resulting from the use
          of the Site, Services or Kinomap Application. Some jurisdictions do
          not allow limitations on implied warranties or the exclusion or
          limitation of certain damages. If these laws apply to you, some or all
          of the above disclaimers, exclusions or limitations may not apply to
          you, and you may have additional rights.
        </p>
      </li>

      <h2 class="mt-5">Compensation by User</h2>
      <li class="list-group-item">
        <p>
          You agree to indemnify the Company and its affiliates, business
          partners, officers, directors, managers, members, employees,
          shareholders, representatives and agents from and against any loss,
          liability, claim, demand, damage or expense (including actual legal
          fees) claimed by any third party due to or arising out of your use of
          this Site or the Services or your breach of any of these Terms.
        </p>
        <p>
          The Company reserves the right to assume the exclusive defense and
          control of any matter subject to compensation by you, which shall not
          excuse your compensation obligations. This compensation obligation
          shall survive the expiration of any Services or termination of the
          Terms.
        </p>
      </li>

      <h2 class="mt-5">Copyright Infringement</h2>
      <li class="list-group-item">
        <p>
          It is the Company's policy to end the registration of any User who
          repeatedly infringes the copyright of others and to promptly remove or
          disable access to allegedly infringing content if the Company receives
          proper notification of the infringement or infringing conduct from the
          copyright owner. If you believe that any content on the Site (e.g.,
          videos, content, images, text, etc.) infringes your copyright, you may
          request the removal of such content from our Site by contacting our
          designated copyright agent (identified below) and providing the
          following information:
        </p>
        <ul>
          <li>
            Identification of the copyrighted content that you believe has been
            infringed. Please describe the content and, if possible, include a
            copy or the location (e.g., URL) of an authorized version.
          </li>
          <li>
            Identification of the content that is claimed to be infringing or to
            be the subject of infringing activity and that is to be removed or
            access to which is to be disabled, and information reasonably
            sufficient to permit us to locate the content;
          </li>
          <li>
            Your name, address, telephone number and (if available) email
            address.
          </li>
          <li>
            A statement by you that you have a good faith belief that use of the
            content you are disclosing is not authorized by the copyright owner,
            its agent, or the law.
          </li>
          <li>
            A statement that the information you have provided is accurate and
            swear that, "under penalty of perjury," you are the copyright owner
            or are authorized to act on the copyright owner's behalf.
          </li>
          <li>
            A signature or electronic equivalent of the copyright owner or its
            authorized representative.
          </li>
        </ul>
      </li>

      <h2 class="mt-5">
        This information must be submitted to the Company's copyright agent at:
      </h2>
      <li class="list-group-item">
        <h5>Kinomap</h5>
        <p>
          14 Rue de la Mairie<br />
          59500 DOUAI<br />
          FRANCE<br />
          Phone: +33 9 51 16 32 60<br />
          Fax: +33 9 56 16 32 60<br />
          Email :
          <a href="mailto:support@kinomap.net">support&#64;kinomap.com</a>
        </p>
      </li>

      <h2 class="mt-5">Additional Provisions</h2>
      <li class="list-group-item">
        <p>
          <u>Dispute Resolution.</u>
          You expressly agree and personally submit to the jurisdiction of the
          French Courts to try and resolve any dispute with the Company, its
          affiliates, subsidiaries, employees, contractors, officers, directors,
          members, shareholders, managers, telecommunication providers and
          content providers or in any other way relating to the Site or the
          Services. The law applicable to any dispute shall be French law.
        </p>
        <hr />
        <p>
          <u>Information</u>
          The Company makes no representation that the content on the Site or
          provided through the Services is appropriate or may be downloaded
          outside the United States or the European Union. If a user accesses
          the Site or uses the Services from outside the United States or the
          European Union, he or she does so at his or her own risk and is liable
          for compliance with the laws of his or her jurisdiction regarding
          online conduct and acceptable content. Personal data that is submitted
          to this Site will be collected, processed, stored, disclosed and
          disposed of in accordance with our Privacy Policy. In addition, such
          personal data may be stored on servers located outside the User's
          jurisdiction of residence.
        </p>
        <hr />
        <p>
          The Terms apply to you or any activity or use of the Site or Services
          and, together with the Privacy Policy and the End User License
          Agreement for each Application you download, constitute the entire
          agreement between you and the Company with respect to the Site and
          Services and replace all other terms, representations, promises or
          discussions.If any provision hereof is or becomes inconsistent with
          any present or future law, rule or regulation of any sovereign
          government or regulatory body having jurisdiction over the subject
          matter of the Terms, such provision shall be deemed superseded or
          modified in accordance with such law, rule or regulation. In all other
          respects, the Terms will remain in full force and effect.
        </p>
      </li>
      <h2 class="mt-5">Legal Notices</h2>
      <li class="list-group-item">
        <h5>Kinomap</h5>
        <p>
          14 Rue de la Mairie<br />
          59500 DOUAI (FRANCE)<br />
          +33 9 51 16 32 60 -
          <a href="mailto:support@kinomap.net">support&#64;kinomap.com</a><br />
          SAS au capital social de 88 968€<br />
          Philippe Moity, Président et Responsable de la rédaction du site.<br />
          Site hébergé chez SCALEWAY 8 rue de la Ville l’Evêque, 75008 Paris,
          France (+33 (0)1 84 13 00 00)<br />
        </p>
      </li>
    </ul>
    <h3 class="text-center my-3 mb-5">
      Questions regarding the Terms should be directed to
      <a href="mailto:support@kinomap.net">support&#64;kinomap.com</a>
    </h3>
  </div>

  <!-- FRENCH VERSION -->
  <div *ngIf="!isEnglish" class="container-fluid content">
    <h1 class="mt-3 text-center">CONDITIONS D'UTILISATION</h1>

    <ul class="list-group text-justify">
      <li class="list-group-item mt-5">
        <p>
          Les éléments ci-dessous concernent la plateforme Kinomap,
          l’application Kinomap ainsi que l’application Tunturi Routes.
        </p>
      </li>
      <h2 class="mt-5">Pour KINOMAP website & les applications KINOMAP</h2>
      <li class="list-group-item">
        <p>
          KINOMAP SAS (ci-après, désigné comme la "Société", "nous" ou
          "KINOMAP") héberge le site web KINOMAP, développe diverses
          applications logicielles KINOMAP et propose (les "Services") par le
          biais de son site web à <a href="/fr/">www.kinomap.com</a> (ci-après,
          désigné comme le "Site"). Le présent texte définit les conditions
          d’utilisation des Service de KINOMAP (ci-après, désigné comme “les
          Conditions”). Ces Conditions s’appliquent aux simples utilisateurs
          ainsi qu’aux utilisateurs inscrits (ci-après, désignés comme les
          “Utilisateurs Enregistrés”).Les Conditions prennent effet dès
          l'utilisation du site ou des services et restent en vigueur jusqu'à
          leur résiliation conformément aux Conditions.Les Utilisateurs
          enregistrés sont tenus d'accepter les Conditions en cliquant sur
          "J'accepte". En acceptant les Conditions, l’Utilisateur certifie qu’il
          a lu et compris le contenu des Conditions, et qu’il accepte les
          obligations qui y sont énoncées.
        </p>
      </li>
      <h2 class="mt-5">Services et inscription</h2>
      <li class="list-group-item">
        <p>
          La Société fournit les Services gratuitement. Toutefois, certains
          services ou fonctionnalités des Services ne sont accessibles qu'aux
          Utilisateurs enregistrés ayant souscrit à un abonnement, y compris
          notamment la possibilité de télécharger et de partager des vidéos sur
          le Site et la possibilité de commenter des vidéos sur le Site.
        </p>
        <p>Au moment de l'inscription :</p>
        <ul>
          <li>
            Vous ne pouvez avoir qu'un seul compte en tant qu’Utilisateur
            Enregistré et devez fournir à la Société, votre nom d'utilisateur,
            votre adresse électronique et votre mot de passe.
          </li>
          <li>
            Vous pouvez également fournir votre prénom et votre nom de famille,
            si vous le souhaitez. Vous ne pouvez pas créer un compte
            d'Utilisateur Enregistré au nom d'une autre personne ou entité.
          </li>
          <li>
            Vous pouvez également vous connecter aux Services en utilisant vos
            informations de connexion Facebook.
          </li>
          <li>
            Vous ne pouvez utiliser le Site et les Services que pour votre usage
            personnel et non pour un usage commercial.
          </li>
          <li>
            Vous ne pouvez pas vous inscrire pour utiliser le Site ou
            télécharger les Services si vous êtes âgé de moins de 15 ans.
          </li>
          <li>
            Pour souscrire à un abonnement payant vous avez la possibilité
            d'utiliser une carte bancaire, ou de passer par une société de
            paiement par internet telle que Stripe, Paypal ou Mercanet.
          </li>
        </ul>
      </li>

      <h2 class="mt-5">Comportement et obligations de l'utilisateur</h2>
      <li class="list-group-item">
        <p>
          Vous acceptez d'utiliser le Site et les Services uniquement à des fins
          légales et acceptez de respecter toutes les lois, règles et
          réglementations applicables dans la région géographique où vous
          résidez, y compris toutes les lois, règles et réglementations
          communautaires, nationales, fédérales, étatiques ou locales. En outre,
          vous acceptez ce qui suit :
        </p>
        <ul>
          <li>
            Vous n'utiliserez pas les Services pour télécharger, poster,
            partager ou transmettre tout contenu qui soit : illégal, abusif,
            menaçant, nuisible, obscène, lubrique, offensant, diffamatoire ou
            autrement répréhensible ;
          </li>
          <li>
            Vous ne devez pas vendre, proposer à la vente ou faire de la
            publicité pour des armes, des munitions, des drogues, de l'alcool,
            de la pornographie ou tout autre bien ou service illégal par le
            biais de l'utilisation du Site ou des Services
          </li>
          <li>
            Vous ne devez pas vous engager dans des activités susceptibles de
            diffuser des virus informatiques, des logiciels malveillants ou
            d'autres programmes, fichiers ou codes conçus pour interrompre,
            détruire, accéder à ou limiter la fonctionnalité de tout logiciel ou
            matériel informatique ou équipement de télécommunications ;
          </li>
          <li>
            Vous ne devez pas diffuser, poster, partager ou transmettre tout
            contenu ou autre matériel par le biais de l'utilisation des Services
            ou du Site qui constitue une publicité non sollicitée, du matériel
            promotionnel, des enquêtes, du spam, du courrier indésirable ou
            d'autres messages non sollicités en vrac ou dupliqués ;
          </li>
          <li>
            Vous ne devez pas perturber ou placer des charges déraisonnables ou
            excessives sur le Site, interférer ou tenter d'obtenir un accès non
            autorisé à toute partie du Site, des Services ou de tout système
            informatique, serveur ou réseau de soutien ;
          </li>
          <li>
            Vous ne devez pas vendre, louer, concéder sous licence ou transférer
            votre inscription d'Utilisateur Enregistré ou votre accès aux
            services ou leur utilisation à des tiers et vous ne devez pas
            utiliser le site ou les services à des fins autres que personnelles
            et non commerciales sans le consentement écrit préalable de la
            Société ;
          </li>
          <li>
            Vous pouvez partager le contenu, y compris les vidéos, de ce Site
            via les méthodes de partage fournies par la Société sur le Site,
            mais vous ne devez pas redistribuer le contenu du Site, de toute
            autre manière ou à des fins commerciales ;
          </li>
          <li>
            Vous ne devez pas usurper l'identité d'une autre personne ou
            présenter de manière inexacte à la Société ou à tout autre
            utilisateur votre véritable identité légale ; vous ne devez pas
            utiliser les Services de manière frauduleuse, trompeuse ou
            mensongère ;
          </li>
          <li>
            Vous ne devez pas reproduire, dupliquer, copier ou faire de
            l'ingénierie inverse sur le site, toute partie de celui-ci ou les
            services, y compris les applications logicielles KINOMAP disponibles
            sur le site ;
          </li>
          <li>
            Vous ne devez pas diffuser, transmettre ou mettre à disposition de
            tiers toute information, élément ou contenu portant atteinte aux
            droits fondamentaux et aux libertés publiques reconnus
            constitutionnellement et dans les traités internationaux.
          </li>
        </ul>
        <h4 class="text-center mt-3">
          Vous pouvez signaler les violations des Conditions en contactant la
          Société à l'adresse
          <a href="mailto:support@kinomap.com">support&#64;kinomap.com</a>.
        </h4>
      </li>

      <h2 class="mt-5">Relations avec les tiers</h2>
      <li class="list-group-item">
        <p>
          Vous reconnaissez et acceptez que vos relations avec des tiers, y
          compris les magasins d'applications mobiles, les annonceurs, les sites
          de réseaux sociaux ou d'autres parties, trouvés sur, ou accessibles
          par ce Site, ou qui fournissent un accès aux Services et à leurs
          produits ou services, sont uniquement entre vous et ces tiers et la
          Société ne sera pas responsable de toute perte ou dommage lié à votre
          utilisation ou interaction avec l'un des éléments précédents.
        </p>
        <p>
          Vos activités sur les sites Web de tiers sont régies par les
          conditions et les politiques de confidentialité de ces sites et non
          par les Conditions.
        </p>
        <p>
          Vous comprenez et reconnaissez que certains des services qui peuvent
          être ou devenir accessibles sur ce Site peuvent être fournis par des
          tiers et que dans certains cas, la Société peut recevoir des frais de
          publicité, de parrainage ou de licence et/ou d'autres compensations de
          la part de tiers.
        </p>
      </li>

      <h2 class="mt-5">Collecte des données globales</h2>
      <li class="list-group-item">
        <p>
          La Société peut partager, vendre, concéder sous licence ou échanger
          les informations globales anonymisées qu'ellerecueille sur les
          utilisateurs de le Site et les vidéos qu'ils regardent, partagent ou
          téléchargent, y compris les informations sur la date, l'heure et le
          lieu de cette utilisation.
        </p>

        <p>
          Vous reconnaissez et acceptez que la Société puisse intercepter,
          collecter, stocker, divulguer, partager et vendre l'ensemble des
          informations anonymisées relatives à votre utilisation du Site et des
          Services, y compris toutes les données associées ou intégrées aux
          vidéos que vous chargez sur notre site. Vous pouvez modifier votre
          consentement à tout moment en adressant un courriel à
          <a href="mailto:support@kinomap.net">support&#64;kinomap.com</a>.
        </p>
        <p>
          Nous vous invitons à consulter notre Politique de confidentialité
          <a href="/privacy">https://www.kinomap.com/privacy</a> pour plus
          d'informations sur les informations que nous recueillons et sur la
          manière dont nous les utilisons. Vous pouvez modifier, supprimer et
          gérer vos informations recueillies par la Société en adressant un
          courriel à
          <a href="mailto:support@kinomap.net">support&#64;kinomap.com</a>.
        </p>
        <p>
          Si vous souhaitez vous désengager, vous devez annuler votre compte
          d’Utilisateur Enregistré, cesser d'utiliser le Site et les Services.
        </p>
      </li>

      <h2 class="mt-5">Modifications des Conditions</h2>
      <li class="list-group-item">
        <p>
          La Société se réserve le droit, à tout moment et à sa seule
          discrétion, de modifier tout ou partie des Services et des Conditions
          sans engager sa responsabilité.
        </p>

        <p>
          Ces amendements prendront effet dès que la Société publiera les
          Conditions telles que révisées sur le Site.
        </p>
        <p>
          Nous nous efforcerons d'informer les Utilisateurs enregistrés du Site
          et/ou des Services par le biais de l'adresse électronique que vous
          avez fournie lors de votre inscription en cas de modification des
          Conditions. La Société utilisera des moyens commercialement
          raisonnables pour tenter de vous informer, via les Services sur votre
          appareil mobile ou par e-mail, que les Conditions ont été modifiées.
        </p>
        <p>
          Vous vous engagez à vérifier régulièrement si vous êtes au courant des
          modifications apportées aux Conditions. Ainsi, vous acceptez et
          convenez d'être lié par les Conditions révisées telles que publiées
          sur le Site au moment de votre utilisation.
        </p>
        <p>
          Si vous n'êtes pas d'accord avec une modification des Conditions, vous
          devez cesser d'utiliser le Site et les Services et annuler votre
          compte.
        </p>
      </li>

      <h2 class="mt-5">Résiliation</h2>
      <li class="list-group-item">
        <p>
          La Société se réserve le droit, à tout moment et à sa seule
          discrétion, de modifier tout ou partie des Services et des Conditions
          sans engager sa responsabilité.
        </p>

        <p>
          Ce droit comprend le droit de mettre fin aux droits de tout
          Utilisateur Enregistré d'utiliser le Site ou les Services en cas de
          mauvaise conduite de l'Utilisateur Enregistré, de menaces ou
          d'allégations à cet égard, de trafic excessif sur le Site ou les
          Services qui empêche l'utilisation et l'accès normaux au Site ou aux
          Services par d'autres utilisateurs, ou de toute violation des
          Conditions.
        </p>
        <p>
          L'utilisateur peut résilier les Conditions à tout moment en cessant
          toute utilisation des Services et du Site, en supprimant ou en
          retirant définitivement toutes les copies des Applications Kinomap des
          ordinateurs, tablettes et appareils mobiles de l'utilisateur et en
          annulant son compte Kinomap d'Utilisateur Enregistré.
        </p>
        <p>
          Les dispositions suivantes survivent à la résiliation : Contenu,
          Exclusion de garanties et limitation de responsabilité, Indemnisation
          par l'utilisateur, Violation des droits d’auteur et les Dispositions
          supplémentaires.
        </p>
      </li>

      <h2 class="mt-5">Contenu</h2>
      <li class="list-group-item">
        <p>
          En tant qu'Utilisateur Enregistré, vous avez la possibilité de
          partager vos vidéos sur le Site. Les vidéos téléchargées par vos soins
          sur le site peuvent être vues par tout le monde dans le monde entier.
        </p>
        <p>
          Les informations suivantes seront accessibles au public avec les
          vidéos que vous téléchargez : votre nom d'Utilisateur Enregistré, la
          date, l'heure et le lieu à partir desquels la vidéo a été téléchargée,
          la date, l'heure et le lieu de création de la vidéo, y compris le
          point de départ, l'itinéraire et le point d'arrivée, les informations
          GPS de l'itinéraire figurant dans la vidéo, y compris l'altitude, la
          vitesse, la fréquence, la puissance, la distance, le lieu et l'heure,
          le rythme cardiaque et le mode de transport utilisé pour filmer la
          vidéo. Si votre nom, votre voix ou votre ressemblance physique
          apparaissent ou sont utilisés dans la vidéo, ils seront également
          accessibles au public.
        </p>
        <p>
          Par la présente, vous accordez à la Société le droit non exclusif, et
          libre de redevances d'utiliser et de reproduire, à toutes fins liées à
          la fourniture par la Société des Services, du Site et de l'Application
          Kinomap Trainer, votre nom et/ou votre nom d'Utilisateur Enregistré,
          votre voix et votre ressemblance physique, ainsi que les noms, les
          voix et la ressemblance physique de toutes les autres personnes
          figurant dans toute vidéo que vous téléchargez sur le Site et que vous
          mettez à disposition du public. Si vous téléchargez une vidéo sur le
          Site accessible seulement à titre privé (dit unlisted) , ce droit
          d’utilisation ne s’appliquera pas. Vous avez la possibilité de mettre
          une vidéo tant en mode privé qu’en mode public à tout moment.
        </p>
        <p>
          Le droit d’utilisation inclut le droit de reproduction qui s’entend de
          la mise en ligne des Vidéos sur le Site internet.
        </p>
        <p>
          Le droit d’utilisation inclut le droit de représentation qui s’entend
          de la diffusion des Vidéos et de leur utilisation par les utilisateurs
          de KINOMAP utilisant soit le player intégrable, soit disposant
          d’applications en marque blanche éditées par Kinomap ou via tout autre
          contrat de licence.
        </p>
        <p>
          Vous déclarez et garantissez à la Société que vous avez obtenu toutes
          les autorisations et tous les consentements nécessaires pour accorder
          ces droits à la Société.
        </p>
        <p>
          Vous ne devez publier, créer et télécharger sur le Site que du contenu
          pour lequel vous disposez de tous les droits, titres et intérêts
          nécessaires pour pouvoir accorder les licences énoncées dans les
          présentes Conditions. En créant du contenu sur le Site ou en
          téléchargeant des vidéos sur le Site, vous déclarez et garantissez à
          la Société que vous disposez de tous les droits, titres et intérêts ou
          de l'autorité appropriée nécessaire pour partager le Contenu et/ou la
          vidéo par le biais de notre Site et que vous ne violez pas les droits
          d'un tiers.
        </p>
        <p>
          Votre licence d'utilisation de l’Application est régie par les
          Conditions et par le Contrat de Licence Utilisateur Final que vous
          avez accepté au moment du téléchargement ou de l'enregistrement.
        </p>
        <p>
          Vous ne devez pas vous approprier, distribuer, vendre, ou extraire le
          Contenu, ni exploiter le Contenu à des fins commerciales.
        </p>
        <p>
          Vous ne pouvez pas utiliser le Contenu du site d'une manière qui n'est
          pas expressément autorisée par les Conditions et, si vous le faites,
          votre droit d'utiliser le Contenu du site prendra automatiquement fin.
        </p>
        <p>
          Le Contenu et le Site peuvent être modifiés ou supprimés sans préavis.
        </p>
        <p>
          Vous pouvez supprimer vos propres vidéos et tout autre contenu du site
          que vous avez précédemment publié et partagé sur le site.
        </p>
        <p>
          Les vidéos et tout autre contenu généré par les utilisateurs sur le
          Site peuvent être changés, modifiés, altérés, supprimés ou retirés à
          tout moment par la Société.
        </p>
      </li>
      <h2 class="mt-5">Assistance technique et force majeure</h2>
      <li class="list-group-item">
        <p>
          Pendant la durée de votre utilisation des services, la Société
          s'efforcera de fournir à ses utilisateurs une assistance technique
          commercialement raisonnable concernant l'utilisation des services et
          du site.
        </p>
        <p>
          Ce soutien est disponible via
          <a
            href="https://support.kinomap.com"
            rel="noopener noreferrer"
            target="_blank"
            >support.kinomap.com</a
          >
          ou par courriel à
          <a href="mailto:support@kinomap.net">support&#64;kinomap.com</a>.
        </p>
        <p>
          En aucun cas, la Société ne sera responsable des retards, des
          défaillances ou des interruptions des services ou de l'accès au Site,
          quelle qu'en soit la raison. Les utilisateurs sont tenus d'informer
          immédiatement la Société de toute interruption de service. La Société
          n'est pas non plus responsable des erreurs, omissions, interruptions,
          retards ou défauts dans les Services causés par la négligence ou
          l'acte délibéré d'un utilisateur ou par son équipement, son
          fournisseur de services Internet ou son opérateur mobile.
        </p>
      </li>

      <h2 class="mt-5">
        Exclusion de garanties et limitation de responsabilité
      </h2>
      <li class="list-group-item">
        <p>
          La Société ne fait aucune déclaration ou garantie de quelque nature
          que ce soit, expresse ou implicite, concernant le fonctionnement du
          Site et des Services, les Applications Kinomap disponibles sur le
          Site, ou les informations, le contenu, les matériaux ou les produits
          inclus sur le Site. Vous convenez expressément que votre utilisation
          du Site, des Services et de l’Application Kinomap se fait à vos
          risques et périls.
        </p>
        <p>
          Dans la mesure où la loi applicable le permet, la Société décline
          toute garantie, expresse ou implicite, y compris, mais sans s'y
          limiter, les garanties implicites de qualité marchande, d'adéquation à
          un usage particulier et de non-violation. La Société ne garantit pas
          que le Site, ses serveurs, le contenu du site ou les Applications
          Kinomap de la Société sont exempts de virus ou d'autres éléments
          nuisibles et l'Utilisateur renonce expressément à toute réclamation à
          ce sujet.
        </p>
        <p>
          La Société ne sera pas responsable des dommages indirects,
          accidentels, spéciaux, punitifs ou consécutifs de toute nature
          résultant de l'utilisation du Site, des Services ou de l’Application
          Kinomap.
        </p>
        <p>
          Les lois de certaines régions n'autorisent pas les limitations des
          garanties implicites ou l'exclusion ou la limitation de certains
          dommages. Si ces lois s'appliquent à vous, tout ou partie des clauses
          de non-responsabilité, des exclusions ou des limitations
          susmentionnées peuvent ne pas s'appliquer à vous, et vous pouvez
          bénéficier de droits supplémentaires.
        </p>
      </li>

      <h2 class="mt-5">Indemnisation par l'Utilisateur</h2>
      <li class="list-group-item">
        <p>
          Vous acceptez d'indemniser et de dégager la Société et ses sociétés
          affiliées, ses partenaires commerciaux, ses dirigeants, ses
          administrateurs, ses gestionnaires, ses membres, ses employés, ses
          actionnaires, ses représentants et ses agents de toute perte,
          responsabilité, réclamation, demande, dommage ou dépense (y compris
          les frais juridiques réels) invoqués par un tiers et liés de quelque
          façon que ce soit à votre utilisation de ce Site ou des Services ou à
          votre violation de l'une de ces Conditions.
        </p>
        <p>
          La Société se réserve le droit d'assumer la défense et le contrôle
          exclusifs de toute question faisant l'objet d'une indemnisation de
          votre part, ce qui ne saurait excuser vos obligations d'indemnisation.
          Cette obligation d'indemnisation survit à l'échéance de tout service
          ou à la résiliation des Conditions.
        </p>
      </li>

      <h2 class="mt-5">Violations des droits d'auteur</h2>
      <li class="list-group-item">
        <p>
          La Société a pour politique de mettre fin à l'inscription de tout
          utilisateur qui enfreint de façon répétée les droits d'auteur d'autrui
          et de retirer ou de désactiver rapidement l'accès au matériel présumé
          en infraction si la Société reçoit une notification appropriée de
          l'infraction ou de la conduite en infraction de la part du
          propriétaire des droits d'auteur. Si vous pensez que des éléments du
          Site (par exemple, des vidéos, du contenu, des images, du texte, etc.)
          violent vos droits d'auteur, vous pouvez demander le retrait de ces
          éléments de notre Site en contactant notre agent de droits d'auteur
          désigné (identifié ci-dessous) et en fournissant les informations
          suivantes :
        </p>
        <ul>
          <li>
            L'identification de l'œuvre protégée par des droits d'auteur que
            vous estimez avoir été violée. Veuillez décrire l'œuvre et, si
            possible, inclure une copie ou l'emplacement (par exemple, l'URL)
            d'une version autorisée.
          </li>
          <li>
            L’identification du matériel qui est prétendument en infraction ou
            qui fait l'objet d'une activité d'infraction et qui doit être retiré
            ou dont l'accès doit être désactivé, et informations raisonnablement
            suffisantes pour nous permettre de localiser le matériel ;
          </li>
          <li>
            Votre nom, votre adresse, votre numéro de téléphone et (si
            disponible) votre adresse électronique.
          </li>
          <li>
            Une déclaration selon laquelle vous pensez de bonne foi que
            l'utilisation des éléments dont vous nous informez n'est pas
            autorisée par le propriétaire du droit d'auteur, son agent ou la
            loi.
          </li>
          <li>
            Une déclaration selon laquelle les informations que vous avez
            fournies sont exactes et que, "sous peine de parjure", vous êtes le
            titulaire des droits d'auteur ou êtes autorisé à agir au nom du
            titulaire des droits d'auteur.
          </li>
          <li>
            Une signature ou l'équivalent électronique du titulaire du droit
            d'auteur ou de son représentant autorisé.
          </li>
        </ul>
      </li>

      <h2 class="mt-5">
        Ces informations doivent être soumises à l'agent des droits d'auteur de
        la Société :
      </h2>
      <li class="list-group-item">
        <h5>Kinomap</h5>
        <p>
          14 Rue de la Mairie<br />
          59500 DOUAI<br />
          FRANCE<br />
          Phone: +33 9 51 16 32 60<br />
          Fax: +33 9 56 16 32 60<br />
          Email :
          <a href="mailto:support@kinomap.net">support&#64;kinomap.com</a>
        </p>
      </li>

      <h2 class="mt-5">Dispositions supplémentaires</h2>
      <li class="list-group-item">
        <p>
          <u>Résolution des litiges.</u>
          Vous acceptez expressément et vous vous soumettez personnellement à la
          compétence des Tribunaux français pour juger et résoudre tout litige
          avec la Société, ses sociétés affiliées, ses filiales, ses employés,
          ses contractants, ses dirigeants, ses administrateurs, ses membres,
          ses actionnaires, ses gestionnaires, ses fournisseurs de
          télécommunication et ses fournisseurs de contenu ou de toute autre
          manière relative au Site ou aux Services. La loi applicable aux
          litiges sera la loi française.
        </p>
        <hr />
        <p>
          <u>Informations</u>
          La Société ne prétend pas que les informations figurant sur le Site ou
          fournies par le biais des Services sont appropriées ou peuvent être
          téléchargées en dehors des États-Unis ou de l'Union européenne.Si un
          utilisateur accède au Site ou utilise les Services depuis l'extérieur
          des États-Unis ou de l'Union européenne, il le fait à ses propres
          risques et est responsable du respect des lois de sa juridiction en
          matière de conduite en ligne et de contenu acceptable. Les
          informations personnelles qui sont soumises à ce site seront
          collectées, traitées, stockées, divulguées et éliminées conformément à
          notre Politique de confidentialité. En outre, ces informations
          personnelles peuvent être stockées sur des serveurs situés en dehors
          de la juridiction de résidence de l'utilisateur.
        </p>
        <hr />
        <p>
          Les Conditions s'appliquent à vous ou à toute activité ou utilisation
          du Site ou des Services et, avec la Politique de confidentialité et le
          Contrat de licence de l'utilisateur final pour chaque Application que
          vous téléchargez, elles constituent l'intégralité de l'accord entre
          vous et la Société concernant le Site et les Services et remplacent
          tous les autres termes, représentations, promesses ou discussions. Si
          une disposition des présentes est ou devient incompatible avec une
          loi, une règle ou un règlement actuel ou futur d'un gouvernement
          souverain ou d'un organisme de réglementation ayant compétence sur
          l'objet des Conditions, cette disposition sera réputée être annulée ou
          modifiée conformément à cette loi, règle ou règlement. À tous les
          autres égards, les Conditions resteront pleinement en vigueur.
        </p>
      </li>
      <h2 class="mt-5">Mentions légales</h2>
      <li class="list-group-item">
        <h5>Kinomap</h5>
        <p>
          14 Rue de la Mairie<br />
          59500 DOUAI (FRANCE)<br />
          +33 9 51 16 32 60 -
          <a href="mailto:support@kinomap.net">support&#64;kinomap.com</a><br />
          SAS au capital social de 88 968€<br />
          Philippe Moity, Président et Responsable de la rédaction du site.<br />
          Site hébergé chez SCALEWAY 8 rue de la Ville l’Evêque, 75008 Paris,
          France (+33 (0)1 84 13 00 00)<br />
        </p>
      </li>
    </ul>
    <h3 class="text-center my-3 mb-5">
      Les questions relatives aux Conditions doivent être adressées à
      <a href="mailto:support@kinomap.net">support&#64;kinomap.com</a>
    </h3>
  </div>
</div>
